/**
 * Nuxt plugin for loading OneTrust cookie management script.
 *
 * This plugin attempts to load the OneTrust script on the client-side,
 * handling potential errors during script loading.
 *
 * @async
 * @throws {Error} If there's an issue loading the OneTrust script
 * @returns {Promise<void>}
 * @see https://www.onetrust.com/
 */
export default defineNuxtPlugin(async () => {
  try {
    const { loadScript } = useOneTrustCookies()
    if (!import.meta.client) return
    await loadScript()
  } catch (err) {
    console.error('Error loadgin one trus', err)
  }
})
